export default __webpack_public_path__ + "static/media/wheel.5f3f5832.png";